import type { WorkspaceDialogService } from '@affine/core/modules/dialogs';

import type { AiCreditsModalReason } from './ai-credits-modal';

/**
 * Opens the AI credits modal unless it is already open. Several paywall
 * errors can arrive for one user action (chat plus a retry, say), and each
 * would otherwise stack another copy.
 */
export function openAiCreditsModal(
  workspaceDialogService: WorkspaceDialogService,
  reason: AiCreditsModalReason
) {
  const alreadyOpen = workspaceDialogService.dialogs$.value.some(
    dialog => dialog.type === 'ai-credits'
  );
  if (alreadyOpen) return;
  workspaceDialogService.open('ai-credits', { reason });
}
